import * as React from "react";
import classNames from "classnames";
import {
  Link as NativeLink,
  LinkProps as NativeLinkProps,
} from "react-router-dom";
import styles from "./Link.module.css";

interface LinkProps extends Omit<NativeLinkProps, "prefix"> {
  className?: string;
  withoutStyles?: boolean;
  disabled?: boolean;
  [key: string]: any;
}

const Link: React.FC<LinkProps> = ({
  className,
  children,
  withoutStyles = false,
  disabled = false,
  ...props
}) =>
  React.createElement(
    disabled ? "span" : React.Fragment,
    {
      ...(disabled ? { className: styles.isDisabled } : {}),
    } as unknown as React.ClassAttributes<HTMLInputElement>,
    <NativeLink
      {...props}
      {...(disabled ? { tabIndex: -1 } : {})}
      className={classNames(className, {
        [styles.wrapper]: !disabled && !withoutStyles,
      })}
    >
      {children}
    </NativeLink>,
  );

export default Link;
